<template>
  <section class="section-main">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="9" lg="10" class="px-5">
          <v-card class="rounded-lg">
            <v-card-title>
              <h4>{{ title }} {{ id }}</h4>
            </v-card-title>
            <v-card-text v-if="contract">
              <v-row>
                <v-col cols="10" lg="4">
                  <fieldset class="px-2">
                    <legend>عنوان</legend>
                    {{ contract.title }}
                  </fieldset>
                </v-col>
                <v-col cols="2" lg="1">
                  <fieldset class="px-2">
                    <legend>وضعیت</legend>
                    <v-icon
                      :class="{
                        'active-icon': contract.isActive,
                        'inactive-icon': !contract.isActive,
                      }"
                    >
                      {{
                        contract.isActive ? "mdi-check-circle" : "mdi-cancel"
                      }}
                    </v-icon>
                    <span>{{ contract.isActive ? "فعال" : "غیرفعال" }}</span>
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="3">
                  <fieldset class="px-2">
                    <legend>مبلغ</legend>
                    {{ commaSep(contract.mainPrice) }} ريال
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="4">
                  <fieldset class="px-2">
                    <legend>شماره قرارداد</legend>
                    {{ contract.number || "ـ" }}
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="4">
                  <fieldset class="px-2">
                    <legend>گروه قرارداد</legend>
                    {{ contract.groupTitle + " " }}
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="4">
                  <fieldset class="px-2">
                    <legend>پروژه</legend>
                    {{ contract.projectTitle + " " }}
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="4">
                  <fieldset class="px-2">
                    <legend>طرف قرارداد</legend>
                    <router-link
                      :to="{
                        name: 'Customer',
                        params: {
                          id: Number(contract.customerFk),
                        },
                      }"
                      ><span>{{ contract.customerName }}</span>
                    </router-link>
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="4">
                  <fieldset class="px-2">
                    <legend>تاریخ شروع</legend>
                    {{ toPersianDate(contract.startDate) }}
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="4">
                  <fieldset class="px-2">
                    <legend>تاریخ پایان</legend>
                    {{ toPersianDate(contract.endDate) }}
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="12">
                  <fieldset class="px-2">
                    <legend>توضیحات</legend>
                    {{ contract.notation }}
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="12">
                  <fieldset class="px-2">
                    <legend>برچسب ها</legend>
                    {{ contract.notation }}
                  </fieldset>
                </v-col>
                <v-col cols="12" lg="12">
                  <v-card class="rounded-lg">
                    <v-card-title> پیوست ها </v-card-title>
                    <v-card-text>
                      <v-data-table
                        :headers="[
                          {
                            text: 'عنوان فایل',
                            align: 'start',
                            value: 'fileName',
                          },
                          {
                            text: 'تاریخ',
                            align: 'start',
                            value: 'createdDate',
                          },
                        ]"
                        :items="contract.attachmentList"
                        :hide-default-footer="!contract.attachmentList?.length"
                      >
                        <template v-slot:no-data>
                          <div class="text-center py-4">پیوستی موجود نیست</div>
                        </template>
                        <!-- <template v-slot:[`item.creatorUserId`]="{ item }">
                          <span dense>{{
                            getUserFullName(item.creatorUserId)
                          }}</span>
                        </template> -->
                        <template v-slot:[`item.createdDate`]="{ item }">
                          <span>{{ toPersianDateTime(item.createdDate) }}</span>
                        </template>
                        <template v-slot:[`item.fileName`]="{ item }">
                          <a
                            :href="
                              getUrl +
                              '/contract/download?id=' +
                              item.id +
                              '&token=' +
                              token
                            "
                          >
                            <v-icon> mdi-download </v-icon>
                            {{ item.fileName }}
                          </a>
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" md="3" lg="2" class="section__banks-sidbar">
          <MenuLeft></MenuLeft>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import { customerMixin } from "@/modules/customers/mixins";
import { contractMixin } from "../mixins";
import { myMixin } from "../../../../mixins.js";
import MenuLeft from "@/components/MenuLeft.vue";

export default {
  mixins: [myMixin, contractMixin, customerMixin],
  name: "ContractDetails",
  components: {
    MenuLeft,
  },
  props: {
    id: {
      default: undefined,
    },
  },
  data() {
    return {
      token: localStorage.getItem("token"),
      title: "جزییات قرارداد",
    };
  },
  computed: {
    ...mapState({
      contract: (state) => state.contracts.item,
      loading: (state) => state.contracts.loading,
    }),
    ...mapGetters(["getUrl"]),
  },
  mounted() {
    console.log(this.id);
    this.getContract(Number(this.id));
  },
  methods: {},
};
</script>
<style scoped>
fieldset {
  border-radius: 5px; /* Adjust the radius as needed */
  border: 2px solid #ccc; /* Optional: Add a border */
  padding: 10px; /* Optional: Add padding */
}
.active-icon {
  color: green;
}
.inactive-icon {
  color: red;
}
</style>
